import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HfPlanDetailsMobComponent } from '../hf-plan-details-mob/hf-plan-details-mob.component';
import { EventsService, UtilService, VariablesService } from 'src/app/shared/services';
import { HealthFirstService } from '../../services/health-first.service';
import { HEALTHFIRST_HOME_INFO } from '../hf-home/home-info';
import { MatIconModule } from '@angular/material/icon';
import { Router } from '@angular/router';

@Component({
  selector: 'app-hf-risk-meter-page',
  standalone: true,
  imports: [
    CommonModule,
    HfPlanDetailsMobComponent,
    MatIconModule
  ],
  templateUrl: './hf-risk-meter-page.component.html',
  styleUrls: ['./hf-risk-meter-page.component.scss']
})
export class HfRiskMeterPageComponent {
  contentInfo = {
    topContent: {
      title: 'we\'ve calculated the risks',
      subTitle: 'and how much you\'d save!',
    },
    meterContent: {
      title: {
        topText: 'Your family health',
        text: 'risk meter',
      },
      desc: 'Prioritising your family\'s unique needs, a HealthFirst plan will protect you from critical illnesses and',
      save: 'save expenses (annualy)',
      amount: '₹ 10,000'
    }
  }

  info = HEALTHFIRST_HOME_INFO;
  id;
  riskText = 'Medium';
  planAmount;

  constructor(
    public util: UtilService,
    public hfService: HealthFirstService,
    private vars: VariablesService,
    private router: Router,
    private events: EventsService
  ) {}

  categoryRisk = {
    10: 'Low',
    20: 'Low',
    30: 'Low',
    40: 'Medium',
    50: 'Medium',
    60: 'High',
    90: 'High'
  }
  nearestValidPerc = 40;

  ngOnInit() {
    this.checkHfData();
    if (this.hfService.calculatorData) {
      this.riskText = this.categoryRisk[this.roundToNearestTen(this.hfService?.calculatorData?.health_meter_perentage)];
      this.nearestValidPerc = this.findNearestValidNumber(this.hfService?.calculatorData?.health_meter_perentage);
    }
    if (typeof window !== 'undefined') {
      document.body.style.background = '#FAFBFB';
    }
  }

  findNearestValidNumber(number) {
    const validNumbers = [30, 40, 60, 90];
  
    // Find the nearest valid number
    const nearestValidNumber = validNumbers.reduce((closest, current) => {
      return Math.abs(current - number) < Math.abs(closest - number) ? current : closest;
    });
  
    return nearestValidNumber;
  }
  

  roundToNearestTen(number) {
    // Calculate the remainder when divided by 10
    const remainder = number % 10;
    // Round down or up to the nearest multiple of 10
    const roundedNumber = remainder >= 5 ? Math.ceil(number / 10) * 10 : Math.floor(number / 10) * 10;
    return roundedNumber;
  }

  onBackClick() {
    this.router.navigate(['/healthfirst/calculator']);
  }

  checkHfData() {
    if (this.vars.hfDashboardData && Object.keys(this.vars.hfDashboardData).length > 0) {
      this.setInfoData(this.vars.hfDashboardData);
    } else {
      this.getHealthPlans();
    }
  }

  setInfoData(data) {
    this.info.plansMob = [];
    const { policies, testimonials, why_should_choose, recommended_plan } = data.data.healthfirst;
    this.info.planDetails.plans = policies.details;
    this.planAmount = policies.plans;
    this.info.recommended_plan = recommended_plan;
    this.info.plans = policies.benefits.filter(item => 'info_1' in item);
    for (const key in policies.plans) {
      if (Object.prototype.hasOwnProperty.call(policies.plans, key)) {
        const element = policies.plans[key];
        this.info.plansMob.push({
          plan: key,
          duration: Object.keys(element)[0],
          amount: element.yearly.amount,
          planId: element.yearly.planId,
          benefits: element.yearly.benefits
        });
      }
    }
    this.info.plans = policies.benefits.filter(item => 'info_1' in item);
    this.info.commentsSection.comments = testimonials;
    this.info.benefits = why_should_choose;
    this.sendEvent({
      eventName: 'allstepcompleted',
      page_name: 'healthfirst_calculator',
    });
    this.vars.pageName = 'healthfirst_calculator';
    this.events.claverTapPush('Healthfirst Calculator', {
      'Event Name': 'allstepcompleted',
    });
  }

  getHealthPlans() {
    this.hfService.getHealthFirstData().subscribe(data => {
      if (data) {
        this.vars.hfDashboardData = data;
        this.setInfoData(data);
      }
    })
  }

  sendEvent(payload) {
    this.events.sendSystemEvent(payload).subscribe(_=> _);
  }

  ngAfterViewInit() {
    if (typeof window !== 'undefined') {
      setTimeout(() => {
        this.util.scrollToTop();
      }, 500);
    }
  }

  ngOnDestroy() {
    if (typeof window !== 'undefined') {
      document.body.style.background = '#fff';
    }
  }
}
